import { isLocaleSupported } from './index.js';
export const getAvailableLanguage = (userLocale, appLocales, options = {}) => {
    if (!options?.languageOnly)
        options.languageOnly = false;
    let newAppLocale = userLocale;
    const isAvailable = appLocales.some(appLocale => {
        if (!isLocaleSupported() &&
            !options.languageOnly &&
            userLocale.split('-')[1] === undefined) {
            return false;
        }
        const userLanguage = isLocaleSupported()
            ? new Intl.Locale(userLocale).minimize().language
            : userLocale.split('-')[0];
        const appLanguage = isLocaleSupported()
            ? new Intl.Locale(appLocale).minimize().language
            : appLocale.split('-')[0];
        const isAvailable = userLanguage === appLanguage;
        if (isAvailable)
            newAppLocale = appLocale;
        return isAvailable;
    });
    return { isAvailable, appLocale: newAppLocale };
};
